<template>
  <div>
    <i :class="`ti ti-refresh ti-spin ti-fw text-${align} ti-${zoom} w-${width}`" />
  </div>
</template>

<script>
  export default {
    name: 'LoaderComponent',
    props: {
      zoom: {
        type: String,
        default: '2x',
      },
      width: {
        type: String,
        default: '100',
      },
      align: {
        type: String,
        default: 'center',
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue